<!-- 证书查询 -->
<template>
  <div class="region" @keydown.enter="search">
    <div class="certificate" v-show="isSearch">
      <!-- <div class="certificate-item" style="margin-top: -10px;">
        <p class="item-title">{{info.title_1}}</p>
        <div class="item-input">
          <input
            type="text"
            v-model.trim="formInfo.number"
            @blur="verificationNumber"
            :placeholder="info.holder_1"
          />
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.number.isError">{{tipsInfo.number.msg}}</div>
        </div>
      </div> -->
      <!-- 证书上的SHA512摘要 -->
      <div class="certificate-item">
        <p class="item-title">{{info.title_certHash}}</p>
        <div class="item-input">
          <textarea
            v-model.trim="formInfo.textValue"
            @blur="verificationCertHash"
            :placeholder="info.holder_certHash"
            :style="{'padding-top':formInfo.textValue?'0px':'10px'}"
          ></textarea>
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.certHash.isError">{{tipsInfo.certHash.msg}}</div>
        </div>
      </div>
      <div class="certificate-item">
        <p class="item-title">{{info.title_2}}</p>
        <div class="item-input">
          <input
            type="text"
            v-model.trim="formInfo.code"
            @blur="verificationCode"
            :placeholder="info.holder_2"
          />
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.code.isError">{{tipsInfo.code.msg}}</div>
        </div>
      </div>
      <div class="certificate-item">
        <p class="item-title">{{info.title_vCode}}</p>
        <div class="item-vcode">
          <input
            type="text"
            v-model.trim="formInfo.vcode"
            @blur="verificationVcode"
            :placeholder="info.holder_vCode"
          />
          <img :src="vcodeUrl?vcodeUrl:''" alt @click="getVcode"/>
          <span @click="getVcode">{{info.change_vCode}}</span>
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.vcode.isError">{{tipsInfo.vcode.msg}}</div>
        </div>
      </div>
      <div class="certificate-operate">
        <button @click="search" v-html="info.search" :disabled="!success" :class="success?'disable':'pendding'"></button>
      </div>
    </div>
    <!-- 查询不到提示 -->
    <div class="error" v-show="isSearchError">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.errTips}}</div>
      </div>
      <div class="error-operate" style="text-align: center;">
        <button @click="continueSearch" >{{info.continue}}</button>
      </div>
    </div>
    <!-- 删除提示 -->
    <div class="error" v-show="deleteError">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.deleteTips}}</div>
      </div>
      <div class="error-operate" style="text-align: center;">
        <button @click="continueSearch" >{{info.continue}}</button>
      </div>
    </div>
    <!-- 过期提示 -->
    <div class="error" v-show="expireEroor">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.expireTips}}</div>
      </div>
      <div class="error-operate" style="text-align: center;">
        <button @click="continueSearch" >{{info.continue}}</button>
      </div>
    </div>
    <!-- 未出证提示 -->
    <div class="error" v-show="notSupport">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.notSupport}}</div>
      </div>
      <div class="error-operate" style="text-align: center;">
        <button @click="continueSearch" >{{info.continue}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { vaildateIDCard, ivaildateBLCard } from "@/utils/validate";
export default {
  data() {
    return {
      isSearch: true, //是否查询
      formInfo: {
        textValue: "",
        number: "",
        certHash: "",
        code: "",
        vcode: ""
      },
      errorText:"",
      success:true,
      tipsInfo: {
        certHash: {
          isError: false,
          msg: this.info.err
        },
        code: {
          isError: false,
          msg: this.info.err
        },
        vcode: {
          isError: false,
          msg: this.info.err
        }
      },
      //验证码图片地址
      vcodeUrl:"",
      expireEroor:false,
      deleteError:false,
      isSearchError:false,
      notSupport:false
    };
  },
  props: ['info'],
  computed: {
  },
  methods: {
    // 验证证书编号
    // 验证证书hash
    verificationCertHash() {
      if (this.formInfo.textValue) {
        var certNumberExp = /^(([A-Z]+\-[A-Z]+\-)|([A-Z]+\-))(\d{16}|\d{18}|\d{20})$/;
        if (certNumberExp.test(this.formInfo.textValue)) {
          this.formInfo.number = this.formInfo.textValue
          this.formInfo.certHash = ""
          this.tipsInfo.certHash.isError = false;
          return true;
        }

        var certHashExp =  /^[a-zA-Z0-9]{128}$/
        if (certHashExp.test(this.formInfo.textValue)) {
          this.formInfo.number = ""
          this.formInfo.certHash = this.formInfo.textValue
          this.tipsInfo.certHash.isError = false;
          return true;
        } else {
          this.tipsInfo.certHash.isError = true;
          this.tipsInfo.certHash.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.certHash.isError = true;
        this.tipsInfo.certHash.msg = this.info.void_certHash;
        return false;
      }
    },
    // 验证证件号码
    verificationCode() {
      let val = this.formInfo.code;
      if (val) {
        if (vaildateIDCard(this.formInfo.code) && this.formInfo.code.length==18) {
          this.tipsInfo.code.isError = false;
          return true;
        } else if(ivaildateBLCard(this.formInfo.code)){
           this.tipsInfo.code.isError = false;
           return true;
        } else {
          this.tipsInfo.code.isError = true;
          this.tipsInfo.code.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.code.isError = true;
        this.tipsInfo.code.msg = this.info.void_2;
        return false;
      }
    },
    // 验证验证码
    verificationVcode() {
      if (this.formInfo.vcode) {
        if (/^([a-z]|[A-Z]|[0-9]){4}$/.test(this.formInfo.vcode)) {
          this.tipsInfo.vcode.isError = false;
          return true;
        } else {
          this.tipsInfo.vcode.isError = true;
          this.tipsInfo.vcode.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.vcode.isError = true;
        this.tipsInfo.vcode.msg = this.info.void_vCode;
        return false;
      }
    },
    //查询
    search() {
      if(this.verificationCertHash() && this.verificationCode() && this.verificationVcode()){
      this.success=false;
      this.$ajax.get('/webapi/validateQuery/certificateQuery', {
        params: {
          certificateNum: this.formInfo.number.trim(),
          certificateHash: this.formInfo.certHash.trim(),
          idcardNumber: this.formInfo.code.trim(),
          vcode: this.formInfo.vcode
        }
      }).then((res) => {
          // console.log(res)
          // success
          // this.goCheckStatus = false
          if (res.data.code === 200) {
            // console.log(res.data)
            this.success=true
            // this.$router.push(this.$route.path + '?status=children&currentType='+ index +'&id='+res.data.extraData.id+'&type='+res.data.extraData.type+'&uid='+res.data.extraData.userId)
            this.$router.push({
              path: "validateShow",
              query: {
                currentType: 2,
                ListIndex: 3,
                certificateNumber: res.data.extraData.certificateNumber,
                type: res.data.extraData.type,
                uid: res.data.extraData.userId,
                partnerId:res.data.extraData.partnerId,
                contractFileId: res.data.extraData.contractFileId || ''
              }
          });
          // Vcode Error
          } else if (res.data.code ===  1005) {
            // ZX-BWX-0720180423911760
             this.tipsInfo.vcode.msg = this.info.err_2;
             this.tipsInfo.vcode.isError = true;
                this.success=true
            this.getVcode()
          } else if (res.data.code === 414) {
            this.$emit('noReal', true)
            this.getVcode()
            this.success=true
          } else if (res.data.code === 450){
            //存证已过期
            this.expireEroor=true;
            this.isSearch=false;
          }else if (res.data.code === 452){
            //未出证
            this.notSupport=true;
            this.isSearch=false;
          }else{
            this.isSearchError=true;
            this.isSearch=false;
            this.searchState = false
            this.getVcode()
            this.success=true
          }
        })
        // console.log("证书格式正确")
      }else{
         this.getVcode()
        this.verificationNumber()
        this.verificationCode()
        this.verificationVcode()
        // console.log("证书格式错误")
      }
      //两个错误弹框提示
      // this.isSearch = false;
      // this.$emit('noReal', true)
    },
     //更换验证码
    getVcode () {
       this.$ajax.get("/webapi/common/getCode").then(res=>{
          if(res.data.code==200){
            this.vcodeUrl='data:image/png;base64,'+res.data.extraData.code
          }
       })
    },
    //继续查询
    continueSearch() {
      this.formInfo.textValue = '';
      this.formInfo.number = '';
      this.formInfo.certHash = '';
      this.formInfo.code = '';
      this.formInfo.vcode = '';

      this.tipsInfo.certHash.isError = false;
      this.tipsInfo.code.isError = false;
      this.tipsInfo.vcode.isError = false;
      this.isSearch = true;
      this.expireEroor=false;
      this.deleteError=false;
      this.isSearchError=false;
      this.notSupport=false;
      this.getVcode()
       this.success=true
    },
  },
  mounted(){
      this.getVcode();
  },
  watch:{
			'$route' () {
				let pos = this.$router.history.current.path.indexOf("cn");
				if (pos) {
          this.tipsInfo.certHash.msg = this.info.void_certHash;
          this.tipsInfo.code.msg = this.info.void_2;
          this.tipsInfo.vcode.msg = this.info.void_vCode;
				}
			}
		}
};
</script>
<style lang="scss" scoped>
.region {
  width: 100%;
  .certificate {
    width: 590px;
    padding-top: 40px;
    margin: 0 auto;
    &-item {
      margin-bottom: 6px;
      .item {
        &-title {
          height: 16px;
          line-height: 16px;
          font-size: 14px;
          color: #fff;
        }
        &-input {
          input {
            outline: none;
            width: 100%;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
          }
          textarea {
            outline: none;
            width: 100%;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
            word-wrap:break-word;
            word-break:break-all;
            font-family: 微软雅黑;
            resize: none;
          }
        }
        &-tips {
          height: 28px;
          div {
            height: 28px;
            line-height: 28px;
            padding-left: 14px;
            font-size: 12px;
            color: #d0444f;
          }
        }
        &-vcode {
          input {
            outline: none;
            width: 198px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
          }
          img {
            width: 90px;
            height: 40px;
            margin-left: 15px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-left: 15px;
            color: #bfbfc2;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
    &-operate {
      text-align: center;
      button {
        height: 46px;
        line-height: 46px;
        width: 284px;
        background-color: #c62e3f;
        color: #fff;
        font-size: 16px;
        &:hover {
          background-color: #ea4b5d;
        }
      }
    }
    .disable{
      background-color: #c62e3f;
    }
    .pendding{
      background-color: #ccc;
      color: #fff;
    }
      .pendding:hover{
        background: #d2d2d2 !important;
        color: #fff;
      }
  }
  .error {
    padding-top: 90px;
    &-tip {
      position: relative;
      width: 592px;
      height: 169px;
      margin: 0 auto;
      background: url("~img/validateQuery/zjcx_fail_bg_img.png");
      color: #fff;
      i {
        position: absolute;
        top: 40%;
        left: 278px;
        transform: translateY(-50%);
        width: 23px;
        height: 23px;
      }
      div {
        position: relative;
        top: 60%;
        left: 72px;
        transform: translateY(-50%);
        width: 450px;
        word-wrap: break-word; 
        word-break: normal;
        font-size: 14px;
        text-align: center;
      }
    }
    &-operate {
      margin-top: 70px;
      text-align: center;
      button {
        height: 46px;
        line-height: 46px;
        width: 284px;
        background-color: #c62e3f;
        color: #fff;
        font-size: 16px;
        &:hover {
          background-color: #ea4b5d;
        }
      }
    }
  }
}

</style>
